import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card contact-card mb-3" }
const _hoisted_2 = { class: "avatar mx-auto bg-white" }
const _hoisted_3 = { class: "rounded-circle letters align-middle" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = {
  key: 0,
  class: "bi bi-envelope-at"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-up contact-bg" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getInitials(_ctx.Contact.firstName + " " + _ctx.Contact.lastName)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.Contact.firstName + " " + _ctx.Contact.lastName), 1),
      _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.Contact.internalEmailAddress)
          ? (_openBlock(), _createElementBlock("i", _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.Contact.internalEmailAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("a", {
                href: 'mailto:' + _ctx.Contact.internalEmailAddress
              }, _toDisplayString(_ctx.Contact.internalEmailAddress), 9, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}